import { setAddinApi, setCurrentUserName } from './api/geotab-client';
import type { GeotabAddinApi } from './api/types';
import { initDashboard } from './dashboard';
import { setDatabaseLabel } from './ui/topbar';

// ── Geotab Add-In entry point ─────────────────────────────────────────────
// Geotab calls: geotab.addin.FleetLumeByEnVue = function(api, state) { return {...} }
// The returned object's methods are called by the MyGeotab shell.

declare global {
  interface Window {
    geotab?: {
      addin: Record<string, (api: GeotabAddinApi, state: unknown) => {
        initialize: (api: GeotabAddinApi, state: unknown, callback: () => void) => void;
        focus: (api: GeotabAddinApi, state: unknown) => void;
        blur: (api: GeotabAddinApi, state: unknown) => void;
      }>;
    };
  }
}

export function registerAddin(): void {
  if (!window.geotab) return;

  window.geotab.addin['FleetLumeByEnVue'] = function (_api: GeotabAddinApi) {
    return {
      initialize(api: GeotabAddinApi, _state: unknown, callback: () => void) {
        document.body.classList.add('addin-mode');
        setAddinApi(api);
        const loginScreen = document.getElementById('loginScreen');
        if (loginScreen) loginScreen.classList.add('hidden');
        const dashboardScreen = document.getElementById('dashboardScreen');
        if (dashboardScreen) dashboardScreen.classList.remove('hidden');
        initDashboard('');
        callback();
        // Populate database label as soon as session info is available
        if (typeof api.getSession === 'function') {
          api.getSession((credentials) => {
            setDatabaseLabel(credentials.database ?? '');
            setCurrentUserName(credentials.userName ?? '');
          });
        }
      },
      focus(_api: GeotabAddinApi, _state: unknown) {
        // Called when user navigates to this add-in page — data already loaded
      },
      blur(_api: GeotabAddinApi, _state: unknown) {
        // Called when user navigates away
      },
    };
  };
}
